import React, { useEffect } from 'react'
import { useChat, useChatPopup, ChatHeaderList } from 'features/Chat'
import type { IChatHeader } from 'features/Chat/Chat.types'

const ChatHeaderListContainer = ({
	showSelected = true,
	isLink = false,
	variant = 'default',
	autoLoad = true,
	onSelect,
}: {
	showSelected?: boolean
	/** Rows open the conversation in the global chat popup instead of inline. */
	isLink?: boolean
	variant?: 'default' | 'rail'
	/** Set false for secondary instances (e.g. the tablet overlay) so headers are not re-fetched. */
	autoLoad?: boolean
	/** Fired after a row loads its thread. Lets the parent swap panes on mobile. */
	onSelect?: (chatHeader: IChatHeader) => void
}) => {
	const {
		state: { chatHeaders, currentEventId, userId },
		actions: { getChatHeaders, getChatMessages },
	} = useChat()
	const { open: openChatPopup } = useChatPopup()

	useEffect(() => {
		if (autoLoad) getChatHeaders()
		// eslint-disable-next-line
	}, [])

	const handleClick = chatHeader => {
		if (isLink) {
			// This used to assign window.location.href, a full page reload, to
			// reach the /chats page. The conversation now opens in place.
			openChatPopup({ eventId: chatHeader._id })
			return
		}

		getChatMessages(chatHeader._id, chatHeader.receiverIds)
		onSelect?.(chatHeader)
	}

	return (
		<ChatHeaderList
			chatHeaders={chatHeaders}
			userId={userId}
			currentEventId={currentEventId}
			showSelected={showSelected}
			onClick={handleClick}
			variant={variant}
		/>
	)
}

export default ChatHeaderListContainer
